export class bModalService {
  constructor ($q) {
    'ngInject';
    this.$q = $q;
  }

  show(config) {
    config.defer = this.$q.defer();
    config.promise = config.defer.promise;
    config.shown = true;
    return config.defer.promise;
  }
}
